var map = {
	"./IMAG00265.jpg": 747541,
	"./IMAG00460.jpg": 621626,
	"./WP_20150627_001.jpg": 371957,
	"./WP_20150720_004.jpg": 780186,
	"./WP_20151107_005.jpg": 94887
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 693453;